/**
 * "Disks" tab — read-only. The portal fixes the disk configuration for now: the image's
 * default OS disk on Standard SSD (RnD subscriptions deny Premium disks by Azure Policy), deleted with
 * the VM, platform-managed key, no data disks.
 * Nothing here looks editable because nothing here can be changed.
 */
import { ReadOnlyField } from './FormFields'
import { Banner } from './AppriseFields'
import { DISK_TYPE_LABELS } from './appriseReview'
import type { AppriseVmFormApi } from './useAppriseVmForm'

export function AppriseDisksTab({ form }: { form: AppriseVmFormApi }) {
  const st = form.config.storage
  return (
    <>
      <Banner>These disk settings are fixed by the portal for now (shown for information — they cannot be changed here).</Banner>
      <ReadOnlyField label="OS disk size" value={st.os_disk_gb === null ? 'Image default' : `${st.os_disk_gb} GiB`}
        hint={st.os_disk_gb === null ? 'The size defined by the image (127 GiB for Windows Server images)' : 'Set by the catalog'} />
      <ReadOnlyField label="OS disk type" value={DISK_TYPE_LABELS[st.os_disk_type] ?? st.os_disk_type}
        hint={st.os_disk_type.startsWith('Premium')
          ? 'Premium disks are denied by the Azure Policy "Deny-Premium-SKU-Disks" in RnD subscriptions — creation will fail'
          : 'Standard SSD, like the existing Apprise VMs (Premium disks are denied by Azure Policy in RnD subscriptions)'} />
      <ReadOnlyField label="Delete with VM" value="Yes" hint="The OS disk is deleted when the VM is deleted" />
      <ReadOnlyField label="Key management" value={st.disk_encryption_set_id ? 'Customer-managed key' : 'Platform-managed key'} />
      <ReadOnlyField label="Encryption at host" value={st.encryption_at_host ? 'Enabled' : 'Disabled'}
        hint="The EncryptionAtHost feature is not registered on the subscription, so it cannot be turned on yet" />
      <ReadOnlyField label="Data disks" value="None" hint="Apprise's storage needs are unknown (PLACEHOLDER) — no data disk is added" />
    </>
  )
}
